import User from '@/models/User'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'
import findIndex from 'lodash/findIndex'

export default {
  namespaced: true,
  state: {
    list: {
      all: [],
      onboarding: [],
      verified: [],
      unverified: []
    },
    listMeta: {
      all: {
        current_page: 0,
        last_page: 1
      },
      onboarding: {
        current_page: 0,
        last_page: 1
      },
      verified: {
        current_page: 0,
        last_page: 1
      },
      unverified: {
        current_page: 0,
        last_page: 1
      }
    },
    userDetails: null
  },

  mutations: {
    setUserList(state, { users, type }) {
      each(users, user => {
        const exist = find(state.list, { id: user.id })
        if (!exist) {
          state.list[type].push(new User(user))
        }
      })
    },

    removeUserDetails(state, payload) {
      const i = findIndex(state.list, { id: payload.id })
      if (i > -1) {
        state.splice(i, 1)
      }
    },

    clearUserList(state, type) {
      state.list[type] = []
    },

    setUserListMeta(state, { meta, type }) {
      state.listMeta[type] = meta
    },

    setUserDetails(state, user) {
      if (user instanceof User) {
        state.userDetails = user
      } else {
        state.userDetails = new User(user)
      }
    },

    setSelectedUserAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.userDetails.avatar = avatar
      } else {
        state.userDetails.avatar = new Avatar(avatar)
      }
    },

    clearUserDetails(state) {
      state.userDetails = null
    },

    userAvatarRemoved(state) {
      state.userDetails.avatar = null
    }
  },

  actions: {
    async getUsers({ commit }, params) {
      const query = User.page(params.page || 1).include('avatar')

      const res = await query
        .custom('users/list')
        .params({
          limit: 20,
          enable_location: false,
          filter: params.filter
        })
        .get()

      commit('setUserList', { users: res.data, type: params.filter.type })
      commit('setUserListMeta', { meta: res.meta, type: params.filter.type })
    },

    async getUserDetails({ commit }, id) {
      const { data } = await Api.get(`users/${id}`)
      commit('setUserDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedUserAvatar', data.data)
    },

    async updateUser({ commit }, formData) {
      const { data } = await Api.put(`users/${formData.id}`, formData)

      commit('setUserDetails', data.data)
    },

    async deleteUser({ commit }, formData) {
      await Api.delete(`users/${formData.id}`)

      commit('removeUserDetails', formData)
    },

    async verifyUser({ commit }, formData) {
      const { data } = await Api.put(`users/${formData.id}/verify`, formData)

      commit('setUserDetails', data.data)
    },

    async rejectUser({ commit }, formData) {
      const { data } = await Api.put(`users/${formData.id}/reject`, formData)

      commit('setUserDetails', data.data)
    }
  }
}
